import React from "react";
import { Dialog, DialogContent, DialogTitle, DialogActions } from "@material-ui/core";

import Button from "../../../../../../components/common/PL/Button/Button";
import VerificarControlRow from "./VerificarControlRow";
import {
  GateControlItem,
  GateControlKey,
  GateControlObservation,
} from "./transportAuthorizationTypes";

import "./VerificarControlesEgresoModal.css";

type VerificarControlesEgresoModalProps = {
  open: boolean;
  onClose: () => void;
  controles: GateControlItem[];
  vigente: boolean;
  onVerificar: (controlId: GateControlKey) => void;
  observations: Partial<Record<GateControlKey, GateControlObservation>>;
  onObservacionTextChange: (controlId: GateControlKey, text: string) => void;
  onObservacionPhotoChange: (controlId: GateControlKey, photo: File | null) => void;
  onSeleccionar: () => void;
};

const VerificarControlesEgresoModal: React.FC<VerificarControlesEgresoModalProps> = ({
  open,
  onClose,
  controles,
  vigente,
  onVerificar,
  observations,
  onObservacionTextChange,
  onObservacionPhotoChange,
  onSeleccionar,
}) => {
  const todoVerificado = controles.every((c) => c.verified);
  const [expandedControlId, setExpandedControlId] = React.useState<GateControlKey | null>(null);

  const handleToggleExpand = (controlId: GateControlKey) => {
    setExpandedControlId((prev) => (prev === controlId ? null : controlId));
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        className: "verificarControlesEgresoModalCard",
        onClick: (e: React.MouseEvent) => e.stopPropagation(),
      }}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle disableTypography className="verificarControlesEgresoModalTitle">
        Verificar controles en portería
      </DialogTitle>
      <DialogContent className="verificarControlesEgresoModalContent">
        {!vigente && (
          <span className="verificarControlesEgresoModalVencidaNote">
            Esta autorización está fuera de vigencia y no puede seleccionarse.
          </span>
        )}
        {controles.length === 0 ? (
          <span className="verificarControlesEgresoModalEmpty">
            No se requieren controles para esta autorización.
          </span>
        ) : (
          controles.map((control) => (
            <VerificarControlRow
              key={control.id}
              control={control}
              observation={observations[control.id]}
              isExpanded={expandedControlId === control.id}
              onToggleExpand={() => handleToggleExpand(control.id)}
              onVerificar={() => onVerificar(control.id)}
              onObservacionTextChange={(text) => onObservacionTextChange(control.id, text)}
              onObservacionPhotoChange={(photo) => onObservacionPhotoChange(control.id, photo)}
            />
          ))
        )}
      </DialogContent>
      <DialogActions className="verificarControlesEgresoModalActions">
        <Button variant="outline" onClick={onClose} className="verificarControlesEgresoModalButton">
          Cerrar
        </Button>
        <Button
          variant="gradient"
          onClick={onSeleccionar}
          className="verificarControlesEgresoModalButton"
          disabled={!todoVerificado || !vigente}
        >
          Seleccionar autorización
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VerificarControlesEgresoModal;
